import { GovernmentFromStrategyIcon } from '@/svgs'
import React from 'react'

function GovernmentFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Governance to Efficiency: Our Government & Public Sector Software Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in government and public sector software development, we build seamless, scalable, and high-performance solutions. Our disciplined approach makes service delivery better, improves security, and maximizes operational efficiency.
            </p>

            <GovernmentFromStrategyIcon />
         </div>
      </section>
   )
}

export default GovernmentFromStrategy
